// other serialization can be moved to it's own file if needed
function serializeMonthDayYear(date) {
  return `${date.month}-${date.day}-${date.year}`;
}

function serializeHourMinute(time) {
  return `${time.hour}-${time.minute}`;
}

function serializeSpecificDate(date) {
  return `${serializeMonthDayYear(date.monthDayYear)}-${serializeHourMinute(
    date.hourMinute
  )}`;
}

export default function serializeSpecificDateWithTimeZone(date) {
  return `${date.timeZoneId}-${serializeSpecificDate(date.specificDate)}`;
}
